import { appRoutes } from 'config';
import { socialProfiles } from 'config/global';
import { Link } from 'core/i18n/navigation';
import type { ReactElement } from 'react';
import { useTranslations } from 'next-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLinkedinIn, faXTwitter } from '@fortawesome/free-brands-svg-icons';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import Logotype from 'assets/icons/logotype.svg';

const Footer = (): ReactElement => {
  const t = useTranslations();
  const copyright = t('footer.copyright');

  return (
    <footer className={styles.outer}>
      <div className={styles.inner.container}>
        <div className={styles.inner.left.container}>
          <Logotype
            className={`${styles.inner.left.logo} text-white`}
            role="img"
            aria-label={t('footer.logoAlt')}
          />
          <p className={styles.inner.left.copyright}>{copyright}</p>
        </div>
        <div className={styles.inner.right.container}>
          <Link
            href={appRoutes.PRIVACY_POLICY}
            className={styles.inner.right.link}
          >
            {t('footer.privacyPolicy')}
          </Link>
          <Link
            href={appRoutes.TERMS_OF_USE}
            className={styles.inner.right.link}
          >
            {t('footer.termsOfUse')}
          </Link>
          <Link
            href={appRoutes.HELP_CENTRE}
            className={styles.inner.right.link}
          >
            {t('footer.helpCentre')}
          </Link>
          <a
            href={socialProfiles.linkedIn}
            className={styles.inner.right.link}
            target="_blank"
            rel="noreferrer noopener"
            aria-label={t('footer.linkedinAria')}
          >
            <FontAwesomeIcon icon={faLinkedinIn as IconProp} />
          </a>
          <a
            href={socialProfiles.x}
            className={styles.inner.right.link}
            target="_blank"
            rel="noreferrer noopener"
            aria-label={t('footer.xAria')}
          >
            <FontAwesomeIcon icon={faXTwitter as IconProp} />
          </a>
        </div>
        <p className={styles.inner.copyright}>{copyright}</p>
      </div>
    </footer>
  );
};

export default Footer;

const styles = {
  outer: 'bg-mf-off-black-950 px-6 font-inter',
  inner: {
    container:
      'max-w-7xl mx-auto flex flex-col lg:flex-row justify-between py-4',
    left: {
      container:
        'text-white flex flex-row lg:gap-6 lg:items-center lg:justify-center',
      logo: 'h-4 py-4 lg:py-0',
      copyright: 'text-white hidden lg:block font-normal',
    },
    right: {
      container:
        'text-white flex flex-col lg:flex-row gap-4 lg:items-center lg:justify-center',
      link: 'text-white text-md font-light',
    },
    copyright: 'text-white lg:hidden font-normal pt-2',
  },
};
